// todo move this file to module
export const LoanOptions = {
    '1': 'فعال',
    '0': 'غیرفعال',
}
